/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useHistory } from "react-router";
import { useAppContext } from "../Components/AppContext";

type NavigateFuncOptions = { replace: boolean, enableChangeTracking?: boolean };

export type NavigateFunc = (path: string, options?: NavigateFuncOptions) => void;

export default function useNavigate(): NavigateFunc {
    const history = useHistory();
    const appContext = useAppContext();

    function navigate(path: string, { replace = false, enableChangeTracking = false } = {}) {
        if (!enableChangeTracking) {
            appContext.changeTracker.clearAll();
        }

        const action = replace ? history.replace : history.push;
        action(path);
    }

    return navigate;
}
